/**
 * Impl dos use cases da assinatura de contrato (acadadmin).
 *
 * @since G.5.24
 */
import type { ContratoExtended, GerarContratoAssinaturaCommand } from '@/domain/model/Contrato';
import type { ContratoAssinaturaGateway } from '@/application/port/out/ContratoAssinaturaGateway';
import type {
  GetContratoAssinaturaUseCase, GerarContratoAssinaturaUseCase,
  RecusarContratoUseCase, RevogarContratoUseCase,
} from '@/application/port/in/ContratoAssinaturaUseCase';

export class GetContratoAssinatura implements GetContratoAssinaturaUseCase {
  constructor(private readonly g: ContratoAssinaturaGateway) {}
  execute(id: string): Promise<ContratoExtended> { return this.g.get(id); }
}
export class GerarContratoAssinatura implements GerarContratoAssinaturaUseCase {
  constructor(private readonly g: ContratoAssinaturaGateway) {}
  execute(cmd: GerarContratoAssinaturaCommand): Promise<ContratoExtended> { return this.g.gerar(cmd); }
}
export class RecusarContrato implements RecusarContratoUseCase {
  constructor(private readonly g: ContratoAssinaturaGateway) {}
  execute(id: string, motivo: string): Promise<ContratoExtended> { return this.g.recusar(id, motivo); }
}
export class RevogarContrato implements RevogarContratoUseCase {
  constructor(private readonly g: ContratoAssinaturaGateway) {}
  execute(id: string, motivo: string): Promise<ContratoExtended> { return this.g.revogar(id, motivo); }
}
